import React from 'react';
import styled from 'styled-components';

export const CardContainer = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 92px;
  gap: 6px;
  padding: 0 12px;
  border-width: 3px 1px 1px 1px;
  border-style: solid;
  border-color: ${({border}) => border };
`;

export const CardNumber = styled.span`
  font-size: 28px;
  font-weight: 700;
  color: ${({color}) => color };
  line-height: 1;
`;

export const CardLabel = styled.span`
  font-size: 14px;
  color: ${({color}) => color };
  text-align: center;
`;

const TopCards = ({ number, label, border, color }) => {
  return (
    <CardContainer border= {border}>
      <CardNumber color={color}>{number}</CardNumber>
      <CardLabel color={color}>{label}</CardLabel>
    </CardContainer>
  );
};

export default TopCards;
